import React, { Component } from "react";
import PropTypes from "prop-types";
import AHButton from "../StyleGuide/AHButton";
import ClickOutside from "../ClickOutside";
import { EMPTY_STRING } from "../../../constants";
import "./styles.css";

class DecisionAlertCard extends Component {
    constructor(props) {
        super(props);

        this.handleYesClick = this.handleYesClick.bind(this);
        this.handleNoClick = this.handleNoClick.bind(this);
    }

    handleYesClick() {
        this.props.yesBtnCallback();
    }

    handleNoClick() {
        this.props.noBtnCallback();
    }

    render() {
        return (
            <div
                className={`${this.props.id}-decision-alert-overlay ${this.props.overlayClassName}`}
            >
                <ClickOutside onClickOutsideCallback={this.props.noBtnCallback}>
                    <div
                        id={this.props.id}
                        className={`decision-alert-card ${this.props.className}`}
                        style={this.props.style}
                    >
                        <div className={"decision-alert-child-container"}>
                            {this.props.children}
                        </div>
                        <div className={"decision-alert-button-container"}>
                            {!this.props.singleBtn && (
                                <div className={"decision-alert-no-btn"}>
                                    <AHButton
                                        id={this.props.id + "-no-btn"}
                                        isOutline={true}
                                        isSecondary={true}
                                        onClick={this.handleNoClick}
                                        size={"medium"}
                                        text={this.props.noBtnTxt}
                                        textStyle={this.props.textStyle}
                                        style={this.props.noBtnStyle}
                                    />
                                </div>
                            )}
                            <div className={"decision-alert-yes-btn"}>
                                <AHButton
                                    id={this.props.id + "-yes-btn"}
                                    onClick={this.handleYesClick}
                                    size={this.props.size || "medium"}
                                    isDisabled={this.props.disableConfirm}
                                    text={this.props.yesBtnTxt}
                                />
                            </div>
                        </div>
                    </div>
                </ClickOutside>
            </div>
        );
    }
}

DecisionAlertCard.propTypes = {
    noBtnCallback: PropTypes.func,
    yesBtnCallback: PropTypes.func,
    noBtnTxt: PropTypes.string,
    yesBtnTxt: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    id: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    overlayClassName: PropTypes.string,
    children: PropTypes.any,
    disableConfirm: PropTypes.bool,
    singleBtn: PropTypes.bool,
    size: PropTypes.string,
    textStyle: PropTypes.object,
    noBtnStyle: PropTypes.object,
};

DecisionAlertCard.defaultProps = {
    noBtnCallback: undefined,
    yesBtnCallback: undefined,
    noBtnTxt: "No",
    yesBtnTxt: "Yes",
    singleBtn: false,
    className: EMPTY_STRING,
    overlayClassName: EMPTY_STRING,
};

export default DecisionAlertCard;
